import Vue from 'vue'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import _ from "lodash"


import 'element-ui/lib/theme-chalk/index.css'

import '~/styles/svg/iconfont.css'
import '~/widgets/icons'
import '~/styles/index.scss'
import '~/styles/font-awesome.less' // 引入font-awsome 图标库

import App from '~/views/App.vue'
import store from '~/store/index'
import bg_watermask from '~/common/waterMask'

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.prototype._ = _;

// 系统版本
Vue.prototype.AppVersion = 'v1.7.9';

Vue.prototype.resp_alert = function (resp, msg, cb) {
    if (resp.code == 0) {
        this.$message({
            message: msg,
            type: 'success'
        });
        if (typeof cb === 'function') cb(resp);
    }
    else {
        this.$message({
            message: resp.msg,
            type: 'error'
        })
    }
}


import router from '~/common/router'
import AccessControl from '~/common/filters/AccessControl'
import AccountService from '~/services/account' //注册全局权限服务
Vue.prototype.Acs = AccountService.can;



// 访问控制
new AccessControl({
    // 排除掉不需要被验证访问控制的路由避免出现重定向死循环问题
    exceptRouters: [
        '/login',
        '/403',
        '/404',
        '/dashboard',
        '/home',
        '/home/customer',
        '/home/lead',
        '/home/my-lead',
        '/home/expire-order',
        '/message/index',
    ]
});

// 向指定元素插入
Vue.directive('watermask', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el) {
        let url = bg_watermask(store.getters.name + '  二一教育', {
            'width': '250px',
            'height': '200px',
            'text-anchor': 'left',
            'font-size': '14px',
            'transform': 'translate(0 0) rotate(-30)',
            'x': '0',
            'y': '8em',
            'fill': '#f3f3f3'
        });
        let background = `url(${url}) 10px 0, url(${url}) 100px 60px,url(${url}) 150px 150px`;
        el.style.background = background;
    }
});

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    created() {
        this.setModuleActiveByRouter();
        // this.checkBrowser();
    },
    methods: {

        // 检查当前使用浏览器
        checkBrowser() {
            // 检查不是 Chrome 浏览器就提示
            if (navigator.userAgent.indexOf("Chrome") <= -1) {
                this.$alert('<b>为了获得最佳使用体验，我们强烈推荐您使用 Chrome(谷歌浏览器) 来访问使用本系统<b/>', '温馨提示', {
                    confirmButtonText: '我知道了',
                    type: 'warning',
                    dangerouslyUseHTMLString: true,
                    center: true
                });
            }
        },

        // 通过当前访问路由设置模块Tab的选中状态
        setModuleActiveByRouter() {
            this.$router.afterEach((to, from) => {
                if (typeof to.meta.module !== 'undefined') {
                    this.$store.dispatch('SwitchModuleId', to.meta.module);
                }
            })
        }
    }
})


// WEBPACK FOOTER //
// ./src/index.js